import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { finalize, tap } from 'rxjs';
import { v4 } from 'uuid';
import { isBackendRequest, logFrontendHttpEvent } from '../../services/http-logging';

function featureFor(endpoint: string): string {
  return endpoint.replace(/^\/api\/v1\//, '').replace(/^\/+/, '').split('/')[0] || 'app';
}

export const httpLoggingInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isBackendRequest(req.url)) return next(req);

  const base = new URL(req.url, 'https://localhost');
  const endpoint = base.pathname;
  const requestId = v4();
  const startedAt = performance.now();
  let statusCode: number | undefined;
  let outcome = 'http.request.cancelled';
  const request = req.clone({ setHeaders: { 'X-Request-ID': requestId } });

  return next(request).pipe(
    tap({
      next: event => {
        if (event.type === HttpEventType.Response) {
          statusCode = event.status;
          outcome = 'http.request.completed';
        }
      },
      error: error => {
        statusCode = typeof error?.status === 'number' ? error.status : undefined;
        outcome = 'http.request.failed';
      },
    }),
    finalize(() => logFrontendHttpEvent({
      event: outcome,
      requestId,
      method: req.method,
      endpoint,
      feature: featureFor(endpoint),
      ...(statusCode === undefined ? {} : { statusCode }),
      durationMs: Math.round(performance.now() - startedAt),
    })),
  );
};
